import * as React from 'react';
import { css, ThemeContext } from 'styled-components';

import { FormGroup_t2_ } from '../..';
import { Box } from '../../Layout/Box';
import { cssDeclaration } from '../../Utils';

export type VALID_INPUT_WRAPPER_VARIANTS =
  | 'row'
  | 'stack';

interface IInputWrapperProps {
  variant?: 'singleInput' | 'multiInput';
}

const InputWrapper: React.FC<IInputWrapperProps> = ({ children, variant = 'singleInput' }) => {
  const { themeTwo: { form: { layout: { wrapper } }}} = React.useContext(ThemeContext);
  const variantTheme =  variant === 'multiInput' ? wrapper.stackRow : wrapper.row;
  const Stack = Box;
  const Row = Box;

  if (variant === 'multiInput') {
    const rowMarginBottom = wrapper.row.margin.bottom;

    return (
      <Stack
        flexWrap={{ base: 'wrap', small: 'nowrap' }}
        childrenStyles={css`
          ${({ theme: { themeTwo }}) => css`
            ${FormGroup_t2_} {
              margin-bottom: ${themeTwo.global.edgeSize[rowMarginBottom]};

              &:not(:last-of-type) {
                flex-grow: 0;
                width: 100%;
                /* margin-right */ ${cssDeclaration(themeTwo, 'margin', variantTheme.margin)};
              }
            }
          `}
        `}
      >
        {children}
      </Stack>
    );
  } else {
    return (
      <Row direction='column' width='100%' {...variantTheme}>
        {<>{children}</>}
      </Row>
    );
  }
};

export default InputWrapper;
